"use client";

import { useEffect } from "react";

const SOVENDUS_TOKEN_KEY = "sovReqToken";
export const SOVENDUS_PIXEL_URL = "https://press-order-api.sovendus.com/ext/image?sovReqToken=";

/**
 * Fires the Sovendus tracking pixel if a token exists.
 */
export function SovendusPixelTracker() {
  useEffect(() => {
    const token = localStorage.getItem(SOVENDUS_TOKEN_KEY);

    if (token) {
      const pixel = document.createElement("img");
      pixel.src = `${SOVENDUS_PIXEL_URL}${token}`;
      pixel.style.display = "none";
      document.body.appendChild(pixel);

      localStorage.removeItem(SOVENDUS_TOKEN_KEY);

    }
  }, []);

  return null;
}
